
export const workSteps = [
  {
    id: 1,
    step: 1,
    title: 'Оставьте заявку',
    description: 'Позвоните нам или оставьте заявку на сайте. Опишите проблему с вашей стиральной, посудомоечной или сушильной машиной.',
    icon: 'ri-phone-line'
  },
  {
    id: 2,
    step: 2,
    title: 'Диагностика',
    description: 'Мастер приедет в удобное для вас время, проведёт полную диагностику техники и определит причину неисправности.',
    icon: 'ri-search-line'
  },
  {
    id: 3,
    step: 3,
    title: 'Ремонт',
    description: 'После согласования стоимости мастер выполнит ремонт с использованием качественных запчастей и профессионального инструмента.',
    icon: 'ri-tools-line'
  },
  {
    id: 4,
    step: 4,
    title: 'Гарантия',
    description: 'Проверяем работу техники, выдаём гарантию на выполненные работы и консультируем по правильной эксплуатации.',
    icon: 'ri-shield-check-line'
  }
];
